
    var riot = require('riot')
    //src: starling/src/tags/perspectives-listing-item-tool-menu.html
riot.tag2('perspectives-listing-item-tool-menu',
  '<ul class="floating-menu_list"> <li class="floating-menu_item" onclick="{editPerspective}" onmouseenter="{delayedHideSubMenus}"> <i class="material-icons floating-menu_icon">text_fields</i> <span class="floating-menu_label">Rename</span> </li> <li ref="colorPickerOption" class="floating-menu_item" onmouseenter="{summonColorPicker}"> <div class="color-picker-toggle-button-swatch floating-menu_icon" riot-style="background-color: {color}"></div> <span class="floating-menu_label">Color</span> <svg class="floating-menu_caret"> <use xlink:href="#caret-right-icon"></use> </svg> <color-picker if="{colorPickerVisible}" positioning="left: 100%; top: 0;" section="color" colors="{colorChoices}" setcolor="{setColor}" onclick="{ignoreClick}" type="tag"></color-picker> </li> <li if="{showAddPointNode()}" class="floating-menu_item" onclick="{addPerspectivePointNode}" onmouseenter="{delayedHideSubMenus}"> <svg class="floating-menu_icon"> <use xlink:href="#add-circle-outline-icon"></use> </svg> <span class="floating-menu_label">Add to map</span> </li> <li if="{!showAddPointNode()}" class="floating-menu_item" onclick="{locatePerspectivePointNode}" onmouseenter="{delayedHideSubMenus}"> <i class="material-icons floating-menu_icon">location_on</i> <span class="floating-menu_label">Find in map</span> </li> <li class="floating-menu_divider"></li> <li class="floating-menu_item" onclick="{deletePerspective}"> <i class="material-icons floating-menu_icon">delete</i> <span class="floating-menu_label">Delete perspective</span> </li> </ul>',
  '',
  'class="floating-menu floating-menu--hidden"', function(opts) {
'use strict';

var _this = this;

var _store_instance = require('../store_instance');

var _store_instance2 = _interopRequireDefault(_store_instance);

var _perspectivesUi = require('lib/perspectives-ui');

var _searchUi = require('lib/search-ui');

var _constants = require('lib/constants');

var _delayHandler = require('lib/delay-handler');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

this.colorChoices = _constants.PERSPECTIVE_COLORS;
this.canvas = this.opts.canvas;
this.canvas.perspectivesListingItemToolMenuTag = this;
this.color = null;

this.summon = function (perspectivesListingItemTag) {
  var _perspectivesListingI = perspectivesListingItemTag.refs.menuButton.getBoundingClientRect(),
      left = _perspectivesListingI.left,
      bottom = _perspectivesListingI.bottom;

  _this.color = perspectivesListingItemTag.color;
  _this.perspectivesListingItemTag = perspectivesListingItemTag;

  _this.root.classList.remove('floating-menu--hidden');

  Object.assign(_this.root.style, {
    left: left + 'px',
    top: bottom + 4 + 'px'
  });

  _this.summoned = true;
  _this.update();
};

this.hide = function () {
  if (_this.summoned) {
    if (_this.perspectivesListingItemTag) {
      _this.perspectivesListingItemTag.refs.main.classList.remove('menu-open');
    }
    _this.perspectivesListingItemTag = null;
    _this.color = null;
    _this.root.classList.add('floating-menu--hidden');
    _this.summoned = false;
    _this.closeColorPicker();
    _this.update();
  }
};

this.deletePerspective = function (e) {
  e.stopPropagation();
  _perspectivesUi.pui.deletePerspective(_this.perspectivesListingItemTag.id);
  _this.hide();
  _this.canvas.perspectivesListingTag.update();
  _this.canvas.nodePerspectivesPanelTag.update();
};

this.editPerspective = function (e) {
  e.stopPropagation();
  _this.perspectivesListingItemTag.startEditing();
  _this.hide();
};

this.showAddPointNode = function () {
  if (_this.perspectivesListingItemTag) {
    var pointNodeTag = _perspectivesUi.pui.getPointNodeTag(_this.perspectivesListingItemTag.id);

    return !Boolean(pointNodeTag);
  } else {
    return true;
  }
};

this.addPerspectivePointNode = function (e) {
  e.stopPropagation();
  var pointNodeTag = _perspectivesUi.pui.getPointNodeTag(_this.perspectivesListingItemTag.id);

  if (!pointNodeTag) {
    _perspectivesUi.pui.addPerspectivePointNodeToMap({
      perspectiveUUID: _this.perspectivesListingItemTag.id,
      clientX: e.clientX,
      clientY: e.clientY
    });
  }
  _this.hide();
};

this.locatePerspectivePointNode = function (e) {
  e.stopPropagation();
  var pointNodeTag = _perspectivesUi.pui.getPointNodeTag(_this.perspectivesListingItemTag.id);
  if (pointNodeTag) {
    _this.canvas.panzoomToTextCenter(pointNodeTag, _searchUi.searchUI.targetScale(), { animate: true });
    _this.canvas.setSelectedElement(pointNodeTag);
  }
};

this.setColor = function (color) {
  _this.perspectivesListingItemTag.color = color;
  _this.color = color;
  _perspectivesUi.pui.editPerspectiveColor({
    color: color,
    perspectiveUUID: _this.perspectivesListingItemTag.id
  });

  _this.perspectivesListingItemTag.update();
  _this.parent.update();
};

this.toggleColorPicker = function (e) {
  e.stopPropagation();
  _this.color = _this.perspectivesListingItemTag.color;
  _this.colorPickerVisible ? _this.closeColorPicker() : _this.summonColorPicker(e);
};

this.summonColorPicker = function (e) {

  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'perspectivecolor',
    delay: _constants.MENU_OPEN_DELAY,
    callback: function callback() {
      if (_this.colorPickerVisible) return;
      _this.colorPickerVisible = true;
      _this.update();
    }
  });
};

this.delayedHideSubMenus = function (e) {
  if (e) {
    e.stopPropagation();
  }
  _delayHandler.delayHandler.initializeDelay({
    action: 'submenus',
    id: 'hide',
    delay: _constants.MENU_OPEN_DELAY,
    callback: function callback() {
      _this.closeColorPicker();
    }
  });
};

this.closeColorPicker = function () {
  _this.colorPickerVisible = false;
  _this.update();
};

this.ignoreClick = function (e) {
  e.stopPropagation();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('perspectives-listing-item-tool-menu')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/perspectives-listing-item-tool-menu.html
// module id = 659
// module chunks = 0